import React from 'react';

const GoogleDriveIconDark: React.FC<{ className?: string }> = ({
  className,
}) => {
  return (
    <svg
      width="16"
      height="13"
      viewBox="0 0 16 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6065 7.79613L5.49677 0H10.5032L15.6387 7.79613H10.6065ZM6.29677 8.43441L3.79355 12.3553H13.4968L16 8.43441H6.29677ZM4.82581 0.957419L0 8.43441L2.50323 12.3553L7.38065 4.87828L4.82581 0.957419Z"
        fill="#EEF7FF"
      />
    </svg>
  );
};

export default GoogleDriveIconDark;
